import { Component } from '@angular/core';
import { RequestedMobileCard } from './requested-mobile-card.model';

@Component({
  selector: 'app-detail-table',
  templateUrl: './requested-mobile-card-table.component.html',
  styleUrls: ['../../../detail-screen/detail-screen.component.css'],
})
export class RequestedMobileCardTableComponent {
  restrictedData: boolean;
  tableColumns: string[];
  tableData: RequestedMobileCard[];
  emptyValuePlaceholder = '-';
  errorText: string;
  showTable: boolean;

  constructor() {
    this.tableColumns = [];
    this.tableData = [];
  }

  getNotificationDateTime(data:any){
    let notificationDateTime = '-';
    if(data.pinMailer && data.pinMailer.status == 'Verzonden'){
      notificationDateTime = data.pinMailer.notificationDateTime;
    } else if (data.notificationPassFactoryDateTime) {
      notificationDateTime = data.notificationPassFactoryDateTime;
    }
    return notificationDateTime;
  }
}
